import { render, staticRenderFns } from "./HospitalizationListTable.vue?vue&type=template&id=894dd4c0&scoped=true&"
import script from "./HospitalizationListTable.vue?vue&type=script&lang=js&"
export * from "./HospitalizationListTable.vue?vue&type=script&lang=js&"
import style0 from "./HospitalizationListTable.vue?vue&type=style&index=0&id=894dd4c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894dd4c0",
  null
  
)

export default component.exports